// frontend/src/hooks/use-branch-owner.ts
import { useQuery } from "@tanstack/react-query";
import { useActiveBranch } from "@/hooks/use-active-branch";
import { resolveBranchOwner } from "@/lib/permissions";
import { branchesQueries } from "@/modules/branches/queries";
import { useSession } from "@/providers/session-provider";

export function useBranchOwner() {
	const session = useSession();
	const { activeBranchId } = useActiveBranch();
	const { data: branches } = useQuery(branchesQueries.fullList());

	return resolveBranchOwner({
		branches,
		activeBranchId,
		sessionDoctorId: session?.id,
	});
}
